// @flow

import { selectTaxesDisplaySetting } from '@gandi/authentication';
import { useTranslator } from '@gandi/translate';
import { Base, Button, Text, Popover, PopoverContainer } from '@gandi/ui';

import { useAppSelector } from 'src/hooks/useAppSelector';

import type { QuotedProduct } from './types';

import styles from './RenewPriceWithOption.scss';

type Props = { quotedProduct: QuotedProduct };

export function RenewPriceWithOption({
  quotedProduct,
}: Props): React.MixedElement | null {
  const { __, formatPrice } = useTranslator();
  const taxesIncluded = useAppSelector(selectTaxesDisplaySetting);

  const price = Number(
    taxesIncluded
      ? quotedProduct.price?.afterTaxes
      : quotedProduct.price?.beforeTaxes,
  );

  if (Number.isNaN(price)) {
    return null;
  }

  function renderOptionPopOver(options: Array<string>) {
    const countMailboxes = options.filter(
      option => option === 'mailboxv2',
    ).length;
    const hasTrusteeOption = !!options.find(option => option === 'trustee');

    return (
      <>
        {countMailboxes > 0 && (
          <div>{__('%(count)d mailboxes', { count: countMailboxes })}</div>
        )}
        {hasTrusteeOption && <div>{__('Trustee')}</div>}
      </>
    );
  }

  return (
    <div>
      <Base className={styles.priceBox}>
        <span>{formatPrice(price, quotedProduct.currency)}</span>{' '}
        <Text size="small" color="light">
          {quotedProduct.duration === 1 ||
          (quotedProduct.duration === 12 && quotedProduct.duration_unit === 'm')
            ? `${__('/year')}`
            : // $FlowFixMe[incompatible-type] type of duration say it may be `undefined`
              `${quotedProduct.duration} ${__('years')}`}
        </Text>
      </Base>

      {quotedProduct.options && (
        <PopoverContainer
          id="quoted-product-options"
          behaviour="click"
          renderReference={getReferenceProps => (
            <Button kind="link" type="button" {...getReferenceProps()}>
              {__('incl. %(count)d additional services', {
                count: quotedProduct.options?.length,
              })}
            </Button>
          )}
        >
          {getPopoverProps => (
            <Popover {...getPopoverProps()}>
              {renderOptionPopOver(quotedProduct.options || [])}
            </Popover>
          )}
        </PopoverContainer>
      )}
    </div>
  );
}
